import React, { useState, useEffect, useContext, useRef } from 'react';
import JobCommentsService from "../../Controller/JobCommentsController";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { formatDateWithFns } from '../../../Common/DateInputFormat';
import useDateFormat from '../../../Common/fetchDateFormat';
import CreateJobComments from './CreateJobComments';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import JobService from "../../Controller/JobController";
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
function JobsCommentPage({ JobID }) {
    const navigate = useNavigate();
    const [JobCommentList, setJobCommentsData] = useState([]);
    JobID = localStorage.getItem('JobID');
    const { theme } = useContext(ThemeContext);
    const [currentJobComments, setCurrentJobComments] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const tableRef = useRef();
    const [isClosed, SetIsClosed] = useState("0");
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[0, 'desc']],
        });
    };
    const fetchJobDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (JobID > 0) {

                const jobDetail = await JobService.GetJobByID(redirectCallback, JobID);
                SetIsClosed(jobDetail[0].IsCompleted);

            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };

    useEffect(() => {
        SetIsClosed(localStorage.getItem("Closed"));
        fetchJobDetail();
        if (JobCommentList.length > 0) {
            initDataTable();
        }
    }, [JobCommentList, localStorage.getItem("Closed")]);
    useEffect(() => {

    }, []);
    const activeDateFormat = useDateFormat();
    const fetchJobComments = async () => {
        try {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy();
            }
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await JobCommentsService.GetAllJobComments(redirectCallback, JobID);
            setJobCommentsData(data);
        } catch (error) {
            console.error('Error fetching Agreement Notifications:', error);
        }
    };

    useEffect(() => {
        if (JobID > 0) {
            fetchJobComments();
        }
        else {
            setJobCommentsData([]);
        }
    }, [JobID]);

    const handleCreateJobCommentClick = () => {
        setCurrentJobComments(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (job) => {
        setCurrentJobComments(job); // Set the notification to be edited
        setIsModalOpen(true);
    };
    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await JobCommentsService.DeleteJobComments(ID);
                    if ($.fn.DataTable.isDataTable(tableRef.current)) {
                        $(tableRef.current).DataTable().destroy();
                    }
                    fetchJobComments();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };

    const handleSuccess = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchJobComments(); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };


    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateJobCommentClick} disabled={isClosed === '1' || isClosed === 1}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>

            <div className='divTable'>
                <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                    <div className="col-sm-12">
                        <div style={{ maxHeight: "460px", overflow: "auto" }}>
                            <table ref={tableRef} className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>User</th>
                                        <th>Updates</th>
                                        <th style={{ textAlign: "right" }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {JobCommentList.map((jobComment, index) => (
                                        <tr key={jobComment.ID} onClick={(isClosed === '0' || isClosed === 0 || localStorage.getItem('LicenseExpired') == "0") ? () => handleEditClick(jobComment) : undefined} style={{ cursor: 'pointer' }}>
                                            <td className="no-wrap"> {formatDateWithFns(jobComment.DateCreated, activeDateFormat)}</td>
                                            <td className="no-wrap">{jobComment.DisplayName}</td>
                                            <td className="no-wrap" dangerouslySetInnerHTML={{ __html: jobComment.Comment }}></td>
                                            <td style={{ textAlign: "right" }}>

                                                <button className={`rightColumn ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ background: "none", border: "none" }} className="text-danger" disabled={isClosed === '1' || isClosed === 1} onClick={(event) => handleDeleteClick(event, jobComment.ID)}>
                                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <CreateJobComments
                    jobComment={currentJobComments}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    JobID={JobID}
                />
            )}
        </div>
    );
}

export default JobsCommentPage;
